import { render } from "./JoinModuleProperties.vue?vue&type=template&id=406f4a49&scoped=true"
import script from "./JoinModuleProperties.vue?vue&type=script&lang=js"
export * from "./JoinModuleProperties.vue?vue&type=script&lang=js"

import "./JoinModuleProperties.vue?vue&type=style&index=0&id=406f4a49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406f4a49"]])

export default __exports__